export function IndicateRowIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M8 0L4 8L4.76837e-07 0L8 0Z' fill='currentColor' />
    </svg>
  )
}
